import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

let nextHintId = 0;

@Component({
  selector: 'app-snack-delete',
  templateUrl: './snack-delete.component.html',
  styleUrls: ['./snack-delete.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  
})
export class SnackDeleteComponent {
  /** Unique per toast: two can overlap while one animates out. */
  readonly hintId = `g15-snack-dismiss-hint-${nextHintId++}`;
  /**
   * Whether this toast stays until dismissed (an error toast, or any toast under the 'persistent'
   * preset). Only then is the dismiss hint rendered: MatSnackBarContainer moves the WHOLE content
   * into its aria-live region, so a hint on every toast was read aloud after every 2-4s success
   * message, telling the user to press a button their focus is not on. On a sticky toast that press
   * is the only way out, which is worth one sentence. The container exists before this component
   * (MatSnackBar builds the ref around it first); an unknown config reads as not sticky.
   */
  readonly sticky: boolean;

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: {
      content: string;
      icon?: string;
      /** Interpolation params for `content` when it is an i18n key carrying placeholders. */
      params?: { [key: string]: unknown };
    },
    private matSnackBarRef: MatSnackBarRef<SnackDeleteComponent>
  ) {
    const config = matSnackBarRef.containerInstance?.snackBarConfig;
    this.sticky = !!config && !(config.duration && config.duration > 0);
  }

  close() {
    this.matSnackBarRef.dismiss();
  }

}
